declare namespace $ {

	type $mol_check_box__title_bog_slop_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_slop_2 = $mol_type_enforce<
		ReturnType< $bog_slop['llm_on'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_textarea__hint_bog_slop_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_bog_slop_4 = $mol_type_enforce<
		ReturnType< $bog_slop['text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_view__sub_bog_slop_5 = $mol_type_enforce<
		ReturnType< $bog_slop['setup'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_slop_6 = $mol_type_enforce<
		ReturnType< $bog_slop['report'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__hint_bog_slop_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__dictionary_bog_slop_8 = $mol_type_enforce<
		ReturnType< $bog_slop['model_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_bog_slop_9 = $mol_type_enforce<
		ReturnType< $bog_slop['llm_model'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_string__hint_bog_slop_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__type_bog_slop_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['type'] >
	>
	type $mol_string__value_bog_slop_12 = $mol_type_enforce<
		ReturnType< $bog_slop['llm_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_link__uri_bog_slop_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_slop_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__title_bog_slop_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_view__sub_bog_slop_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_slop_verdict__tier_bog_slop_17 = $mol_type_enforce<
		ReturnType< $bog_slop['tier'] >
		,
		ReturnType< $bog_slop_verdict['tier'] >
	>
	type $bog_slop_verdict__index_bog_slop_18 = $mol_type_enforce<
		ReturnType< $bog_slop['index_label'] >
		,
		ReturnType< $bog_slop_verdict['index'] >
	>
	type $bog_slop_verdict__label_bog_slop_19 = $mol_type_enforce<
		ReturnType< $bog_slop['tier_label'] >
		,
		ReturnType< $bog_slop_verdict['label'] >
	>
	type $bog_slop_verdict__note_bog_slop_20 = $mol_type_enforce<
		ReturnType< $bog_slop['paras_label'] >
		,
		ReturnType< $bog_slop_verdict['note'] >
	>
	type $mol_view__sub_bog_slop_21 = $mol_type_enforce<
		ReturnType< $bog_slop['metric_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_slop_22 = $mol_type_enforce<
		({ 
			'bog_slop_state': ReturnType< $bog_slop['status_kind'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_slop_23 = $mol_type_enforce<
		ReturnType< $bog_slop['status'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_slop_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_slop_bar__title_bog_slop_25 = $mol_type_enforce<
		ReturnType< $bog_slop['metric_title'] >
		,
		ReturnType< $bog_slop_bar['title'] >
	>
	type $bog_slop_bar__value_bog_slop_26 = $mol_type_enforce<
		ReturnType< $bog_slop['metric_value'] >
		,
		ReturnType< $bog_slop_bar['value'] >
	>
	type $bog_slop_bar__portion_bog_slop_27 = $mol_type_enforce<
		ReturnType< $bog_slop['metric_portion'] >
		,
		ReturnType< $bog_slop_bar['portion'] >
	>
	export class $bog_slop extends $mol_page {
		popup( ): boolean
		llm_on( next?: boolean ): boolean
		Switch( ): $mol_check_box
		text( next?: string ): string
		Input( ): $mol_textarea
		setup( ): readonly(any)[]
		Setup( ): $mol_view
		report( ): readonly(any)[]
		Report( ): $mol_view
		model_dict( ): Record<string, any>
		llm_model( next?: string ): string
		llm_key( next?: string ): string
		empty_hint( ): string
		tier( ): string
		index_label( ): string
		tier_label( ): string
		paras_label( ): string
		metric_rows( ): readonly(any)[]
		status_kind( ): string
		status( ): readonly(any)[]
		note( ): string
		metric_title( id: any): string
		metric_value( id: any): string
		metric_portion( id: any): number
		title( ): string
		attr( ): ({ 
			'bog_slop_popup': ReturnType< $bog_slop['popup'] >,
		})  & ReturnType< $mol_page['attr'] >
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Model( ): $mol_select
		Key( ): $mol_string
		Keys_link( ): $mol_link
		Empty( ): $mol_view
		Verdict( ): $bog_slop_verdict
		Metrics( ): $mol_view
		Status( ): $mol_view
		Note( ): $mol_view
		Metric( id: any): $bog_slop_bar
	}
	
	type $mol_view__sub_bog_slop_verdict_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_slop_verdict_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_slop_verdict_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_slop_verdict_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_slop_verdict extends $mol_view {
		Index( ): $mol_view
		Label( ): $mol_view
		Note( ): $mol_view
		Side( ): $mol_view
		tier( ): string
		index( ): string
		label( ): string
		note( ): string
		attr( ): ({ 
			'bog_slop_tier': ReturnType< $bog_slop_verdict['tier'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
	type $mol_view__sub_bog_slop_bar_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_slop_bar_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_slop_bar_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_portion__portion_bog_slop_bar_4 = $mol_type_enforce<
		ReturnType< $bog_slop_bar['portion'] >
		,
		ReturnType< $mol_portion['portion'] >
	>
	export class $bog_slop_bar extends $mol_view {
		Title( ): $mol_view
		Value( ): $mol_view
		Head( ): $mol_view
		portion( ): number
		Bar( ): $mol_portion
		title( ): string
		value( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=slop.view.tree.d.ts.map